var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestSuite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0C1.89 0 1 0.89 1 2V6C1 7.11 1.89 8 3 8H0V10H12V8H9C10.11 8 11 7.11 11 6V2C11 0.89 10.11 0 9 0H3ZM3 2H9V6H3V2ZM2 12V17V19H9V17H4V12H2ZM13 12C11.89 12 11 12.89 11 14V18C11 19.11 11.89 20 13 20H10V22H22V20H19C20.11 20 21 19.11 21 18V14C21 12.89 20.11 12 19 12H13ZM13 14H19V18H13V14Z",
    fill: "#A1A9B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 4H14.1111C13.8164 4 13.5338 4.12643 13.3254 4.35147C13.1171 4.57652 13 4.88174 13 5.2V10H14.1111V7.6H15.2222V10H16.3333V5.2C16.3333 4.88174 16.2163 4.57652 16.0079 4.35147C15.7995 4.12643 15.5169 4 15.2222 4V4ZM15.2222 6.4H14.1111V5.2H15.2222V6.4ZM19.1111 4H16.8889V10H18V7.6H19.1111C19.4058 7.6 19.6884 7.47357 19.8968 7.24853C20.1052 7.02348 20.2222 6.71826 20.2222 6.4V5.2C20.2222 4.88174 20.1052 4.57652 19.8968 4.35147C19.6884 4.12643 19.4058 4 19.1111 4V4ZM19.1111 6.4H18V5.2H19.1111V6.4ZM22.4444 5.2V8.8H23V10H20.7778V8.8H21.3333V5.2H20.7778V4H23V5.2H22.4444Z",
    fill: "#A1A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSuite);
export default __webpack_public_path__ + "static/media/test-suite.f66b8545.svg";
export { ForwardRef as ReactComponent };